// common
export const PATH_MAIN_ROUTE = '/';
export const PATH_ACCESS_FORBIDDEN = '/access-forbidden';
export const PATH_LOGOUT = '/logout';
export const PATH_MANAGE_ACCOUNT = '/manage-account';
export const PATH_USER_MANAGEMENT = '/user-management';
export const PATH_QUALITY_MANAGEMENT = '/quality-management';

// forecasting
export const PATH_FORECASTING_STUDIO = '/forecasting-studio';
export const PATH_FORECASTING_STUDIO_CREATE = '/forecasting-studio/create';
export const PATH_FORECASTING_STUDIO_EDIT = '/forecasting-studio/edit';
export const PATH_FORECASTING_STUDIO_VIEW = '/forecasting-studio/view';

// scheduling
export const PATH_SCHEDULING_STUDIO = '/scheduling-studio';
export const PATH_SCHEDULING_STUDIO_CREATE = '/scheduling-studio/create';
export const PATH_SCHEDULING_STUDIO_EDIT = '/scheduling-studio/edit';
export const PATH_SCHEDULING_STUDIO_VIEW = '/scheduling-studio/view';
export const PATH_SCHEDULING_STUDIO_CREATE_COMPOSER = '/scheduling-studio/create/composer';
export const PATH_SCHEDULING_STUDIO_EDIT_COMPOSER = '/scheduling-studio/edit/composer';
export const PATH_SCHEDULING_STUDIO_VIEW_COMPOSER = '/scheduling-studio/view/composer';

// PTO
export const PATH_REQUESTS = '/scheduling/requests';

// Reports
export const PATH_REPORTS_ADHERENCE = '/reports/adherence';

// administration
export const PATH_ADMINISTRATION_PEOPLE = '/administration/people';
export const PATH_ADMINISTRATION_QUEUES = '/administration/queues';
export const PATH_ADMINISTRATION_DATA_IMPORT = '/administration/data-import';
export const PATH_ADMINISTRATION_SKILLS = '/administration/skills';
export const PATH_ADMINISTRATION_SHIFTS = '/administration/shift-templates';
export const PATH_ADMINISTRATION_SCHEDULE_ELEMENTS = '/administration/schedule-elements';

// my schedule
export const PATH_MY_SCHEDULE = '/my-schedule';
export const PATH_MY_SCHEDULE_MONTHLY = `${PATH_MY_SCHEDULE}/monthly`;
export const PATH_MY_SCHEDULE_WEEKLY = `${PATH_MY_SCHEDULE}/weekly`;

// schedule adherence
export const PATH_SCHEDULE_ADHERENCE = '/schedule-adherence';
export const PATH_SCHEDULE_ADHERENCE_SETTINGS = '/schedule-adherence/settings';
export const PATH_SCHEDULE_ADHERENCE_HISTORY = '/schedule-adherence/history';
export const PATH_REAL_TIME_ADHERENCE = '/schedule-adherence/real-time-adherence';

// intraday management
export const PATH_INTRADAY_MANAGEMENT = '/intraday';
